export default __webpack_public_path__ + "static/media/icon-remove-plan-rec.b2689e56.svg";